

// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Mixins } from 'vue-mixin-decorator';

// Constants
import Assets from '@/constants/assets.ts';

// Components
import Input, {
    InputType,
    InputStyle,
} from '@/shared/components/input.component.vue';
import FieldSet from '@/shared/components/field-set.component.vue';

// Mixins
import ErrorMixin from '@/shared/mixins/error.mixin';

// Services
import UtilsService from '@/core/services/utils.service';

// interface MixinInterface extends ErrorMixin {}

@Component({
    components: {
        FieldSet,
        Input,
    },
})
export default class CompanionPartial extends Mixins<ErrorMixin> (ErrorMixin) {
    @Prop({ default: 0 }) private index!: number;
    @Prop() private companion!: any;
    @Prop() private formError!: any;


    private inputType = InputType;
    private nifMask = '';


    @Watch('formError')
    private watchFormError(newVal: any, oldVal: any) {
        this.error = newVal;
    }

    @Watch('companion.client.user.profile.nif')
    private watchNif(newVal: string, oldVal: string) {
        this.nifMask = UtilsService.setNifMask(newVal, this.nifMask);
    }


    private created() {
        this.error = this.formError;
    }


    public checkMandatoryFields() {
        let result = true;

        if ( (this.companion.client.user as any).firstName === '' ) {
            this.error.purchaseLines[0].companionPurchaseLine[this.index].client.user.firstName = 'Campo vacío';
            result = false;
        }
        if ( (this.companion.client.user as any).email === '' ) {
            this.error.purchaseLines[0].companionPurchaseLine[this.index].client.user.email = 'Campo vacío';
            result = false;
        }
        const phone = (this.companion.client.user as any).profile.phone;
        if ( !phone || phone === '' ) {
            this.error.purchaseLines[0].companionPurchaseLine[this.index].client.user.profile.phone = 'Campo vacío';
            result = false;
        }

        return result;
    }
}

